import type { RecordUnion } from 'components/framework/models/generated/types';
import RecordAction from '../RecordAction';
import flagRecord from 'components/common/Attributes/DeliveryRisks/flagRecordHelper';
import type ApplicationModel from 'components/framework/ApplicationModel';

export class RemoveAtRiskAction extends RecordAction<RecordUnion> {
  recordTypes = ['Epic', 'Feature', 'Requirement'];

  get title() {
    return 'Remove at risk flag';
  }

  showForRecord(record: ApplicationModel): record is RecordUnion {
    if (!super.showForRecord(record)) {
      return false;
    }

    const manualRiskComment =
      'manualRiskComment' in record ? record.manualRiskComment : undefined;

    const project = 'project' in record ? record.project : undefined;
    const projectConfiguration = project?.projectConfiguration;

    return (
      !(manualRiskComment === undefined || manualRiskComment === null) &&
      !!projectConfiguration?.projectRisksConfiguration?.enabled &&
      !!projectConfiguration?.projectRisksConfiguration?.manuallyFlagged
    );
  }

  async runForRecords(records: RecordUnion[]) {
    await Promise.all(
      records
        // Filtering here to avoid unnecessary changes when using multi-select
        .filter(r => this.showForRecord(r))
        .map(async record => flagRecord(record.typename, record.id, null))
    );
  }
}
